var ButtonSize;

(function (ButtonSize) {
  ButtonSize[ButtonSize["Small"] = 12] = "Small";
  ButtonSize[ButtonSize["Medium"] = 16] = "Medium";
  ButtonSize[ButtonSize["Large"] = 24] = "Large";
  ButtonSize[ButtonSize["XLarge"] = 32] = "XLarge";
})(ButtonSize || (ButtonSize = {}));

var ButtonType;

(function (ButtonType) {
  ButtonType["Primary"] = "BUTTON/PRIMARY";
  ButtonType["Secondary"] = "BUTTON/SECONDARY";
  ButtonType["Tertiary"] = "BUTTON/TERTIARY";
  ButtonType["Full"] = "BUTTON/FULL";
  ButtonType["FlatPrimary"] = "BUTTON/FLAT_PRIMARY";
  ButtonType["FlatSecondary"] = "BUTTON/FLAT_SECONDARY";
  ButtonType["Plain"] = "BUTTON/PLAIN";
  ButtonType["Destructive"] = "BUTTON/DESTRUCTIVE";
  ButtonType["Link"] = "BUTTON/LINK";
  ButtonType["PrimaryPill"] = "BUTTON/PRIMARY_PILL";
  ButtonType["SecondaryPill"] = "BUTTON/SECONDARY_PILL";
  ButtonType["TertiaryPill"] = "BUTTON/TERTIARY_PILL";
})(ButtonType || (ButtonType = {}));

var IconButtonType;

(function (IconButtonType) {
  IconButtonType["Primary"] = "BUTTON/PRIMARY";
  IconButtonType["Secondary"] = "BUTTON/SECONDARY";
  IconButtonType["Tertiary"] = "BUTTON/TERTIARY";
  IconButtonType["Full"] = "BUTTON/FULL";
  IconButtonType["FlatPrimary"] = "BUTTON/FLAT_PRIMARY";
  IconButtonType["FlatSecondary"] = "BUTTON/FLAT_SECONDARY";
  IconButtonType["Plain"] = "BUTTON/PLAIN";
  IconButtonType["Destructive"] = "BUTTON/DESTRUCTIVE";
  IconButtonType["PrimaryPill"] = "BUTTON/PRIMARY_PILL";
  IconButtonType["SecondaryPill"] = "BUTTON/SECONDARY_PILL";
  IconButtonType["TertiaryPill"] = "BUTTON/TERTIARY_PILL";
})(IconButtonType || (IconButtonType = {}));

var ButtonState;

(function (ButtonState) {
  ButtonState["Default"] = "BUTTON/DEFAULT";
  ButtonState["Loading"] = "BUTTON/LOADING";
  ButtonState["Success"] = "BUTTON/SUCCESS";
  ButtonState["Error"] = "BUTTON/ERROR";
})(ButtonState || (ButtonState = {}));

var ButtonPadding;

(function (ButtonPadding) {
  ButtonPadding["None"] = "BUTTON/PADDING/NONE";
  ButtonPadding["Default"] = "BUTTON/PADDING/DEFAULT";
  ButtonPadding["Wide"] = "BUTTON/PADDING/WIDE";
})(ButtonPadding || (ButtonPadding = {}));

export { ButtonPadding, ButtonSize, ButtonState, ButtonType, IconButtonType };
